module.exports = __webpack_public_path__ + "9720e1fa.svg";